import RestService from './RestService';

async function getTracker({ domain, page }) {
	const res = await RestService.performRestOpNext(`tracker/get`, {
		domain,
		page
	});
	return res;
}

export default {
	getTracker
}